<template>

    <v-card outlined color="#E7EEF6" class="rounded" style="border: 1px solid #B8CFDD;">
        <v-card-text class="pa-0">
            <v-row class="ma-0">
                <v-col cols="12" class="pb-0">
                    <span style="color: grey">{{ formatLongDate(data.creationDate) }}</span>
                </v-col>
            </v-row>
            <v-row class="ma-0">
                <v-col cols="12" class="py-1 d-flex align-center justify-space-between">
                    <span class="black--text" style="font-size: 16px;">{{ $t('wkt.client.expensesheets.detail-window.amount') }}</span>
                    <h3 class="black--text">{{ formatCurrency(data.amount) }}</h3>
                </v-col>
            </v-row>
            <v-row class="ma-0">
                <v-col cols="12" class="pt-0 d-flex align-center justify-space-between">
                    <span style="color: grey">{{ data.projectName ? data.projectName : '--' }}</span>                                            
                    <span :style="`display: block; white-space: nowrap; color: ${getStatusColor(data.status)}`">{{ getStatusText(data.status) }}</span>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider v-if="[-1,0,2].includes(data.status)"></v-divider>
        <v-card-actions>
            <v-spacer v-if="!$vuetify.breakpoint.mobile"></v-spacer>
            <v-btn v-if="[-1,2].includes(data.status)" text color="#185EA9" @click="$emit('edit-expense-sheet')">{{ $t('wkt.client.expensesheets.detail-window.button-edit') }}</v-btn>                                        
            <v-spacer v-if="$vuetify.breakpoint.mobile"></v-spacer>
            <v-btn v-if="[-1,2].includes(data.status)" text color="#185EA9" :disabled="!hasItems" @click="$emit('confirm-send-expense-sheet')">{{ $t('wkt.client.expensesheets.detail-window.button-send') }}</v-btn>
            <v-btn v-if="[0].includes(data.status)" :disabled="!isEmployeeCreator" text color="#185EA9" @click="$emit('cancel-expense-sheet-request')">{{ $t('wkt.client.expensesheets.detail-window.button-cancel_request') }}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script> 
import BaseModule from '../../common/BaseModule.js'

export default {
    name: 'ExpenseSheetMobileHeader',
    mixins: [BaseModule],
    props: ['data','employeeId','hasItems'],
    computed: {
        isEmployeeCreator() {
            return this.employeeId && this.employeeId === this.data.creatorId;
        }
    },
    methods: {
        onWheel(event) {
            event.stopPropagation();
        },
    }
};
</script>
